import { render, staticRenderFns } from "./TCGAboxplotModal.vue?vue&type=template&id=7f1e1cce&scoped=true&"
import script from "./TCGAboxplotModal.vue?vue&type=script&lang=js&"
export * from "./TCGAboxplotModal.vue?vue&type=script&lang=js&"
import style0 from "./TCGAboxplotModal.vue?vue&type=style&index=0&id=7f1e1cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1e1cce",
  null
  
)

export default component.exports